import React from 'react';
import { cn } from '@/lib/utils';

const CopperButton = React.forwardRef(({ 
  className, 
  children, 
  disabled = false,
  onClick,
  type = 'button',
  size = 'md',
  ...props 
}, ref) => {
  const sizeClasses = {
    sm: 'h-[28px] px-4 text-xs',
    md: 'h-[44px] px-6 text-sm',
    lg: 'h-[52px] px-8 text-base',
    xl: 'h-[60px] px-10 text-lg'
  };

  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'relative inline-flex items-center justify-center gap-2',
        'rounded-[var(--radius-xl)] font-semibold font-["Sora"]',
        'bg-copper-gradient text-white',
        'transition-all duration-180',
        'overflow-hidden',
        'hover-lift',
        'focus-ring',
        'interactive',
        !disabled && 'hover:shadow-[var(--shadow-copper-hover)]',
        !disabled && 'active:scale-[0.98]',
        disabled && 'disabled opacity-50 cursor-not-allowed',
        sizeClasses[size],
        className
      )}
      style={{
        boxShadow: !disabled ? 'var(--shadow-copper)' : 'var(--shadow-sm)'
      }}
      data-testid={props['data-testid']}
      {...props}
    >
      {/* Metallic Highlight Overlay */}
      <span className="metallic-highlight absolute inset-0" />
      
      {/* Content */}
      <span className="relative z-10 flex items-center gap-2">
        {children}
      </span>
    </button>
  );
});

CopperButton.displayName = 'CopperButton';

export { CopperButton };